<h2 class="my-1">Import / Export</h2>
<p>
  Use the export and import functionality below to make bulk changes to your
  product database in Excel. Please use with caution.
</p>

<p>
  <strong>Note: </strong> This functionality cannot be used to delete products
  or stock items, please contact HireLogic support to perform a bulk deletion.
</p>
<div class="flex flex-row space-x-4">
  <a mat-flat-button (click)="exportProducts()" [disabled]="loading"
    >Export Products</a
  >
  <input
    type="file"
    class="hidden"
    id="file"
    [disabled]="loading"
    (change)="handleImportFileSelected($event.target)"
  />
  <label
    for="file"
    class="mdc-button mdc-button--raised mat-mdc-raised-button mat-unthemed mat-mdc-button-base cursor-pointer flex flex-row items-center justify-center space-x-4"
    [class.disabled]="loading"
  >
    <mat-icon>upload</mat-icon>
    <p>Import products</p>
  </label>
</div>
